import Chat from '@/generated/classes/Chat';
export default class ChatExtend extends Chat {
  constructor() {
    super();
  }
}
